import i18next from 'i18next';
import { Map } from "immutable";
import { Updater } from "widgets-for-react";
import { ArrayArg } from "../../shared";
import { LookupData } from '../../subscription/subscriptionState';
import { buildValidator, isValidatorPassed, Validator, validatorBuilders, ValidatorResult, validatorResultBuilders } from "../../validator/validator";

export type PaymentType =
  "IDeal" | "Visa" | "MasterCard" | "PayPal" | "Banccontact" | "Maestro"

export const AllPaymentTypes:Array<PaymentType> = 
  [ "IDeal", "Visa", "MasterCard", "PayPal", "Banccontact", "Maestro"]

const PaymentTypesLabels:Map<string, string> = 
  Map<string, string>()
  .set("IDeal", "iDEAL")
  .set("Visa", "Visa")
  .set("MasterCard", "MasterCard")
  .set("PayPal", "PayPal")
  .set("Banccontact", "Bancontact")
  .set("Maestro", "Maestro")

export const paymentTypeLabel = (pt:string | undefined) : string => {
  try {
    return pt == undefined ? "" : PaymentTypesLabels.get(pt)!
  } catch (error) {
    return ""
  }
}

export type IDealIssuer = ArrayArg<LookupData["IDealIssuers"]>

export const emptyIDealIssuer : IDealIssuer = { BIC:"", Created:"", Modified:"", Id:-1, Title:"" }

export type PaymentMethod = Partial<{
  paymentType:PaymentType,
}> & {
  iDealIssuer:Partial<IDealIssuer>
}

export const emptyPaymentMethod : PaymentMethod = { iDealIssuer:{} }

const paymentMethodValidator = buildValidator<PaymentMethod>({
  iDealIssuer:[b => 
    b.fromPromise(async(state,v) => 
      state.paymentType != undefined && state.paymentType != "IDeal" ? true : undefined)
    .or(
      b.fields({
        Title:[b => b.notEmpty(), validatorBuilders.string("Title", () => i18next.t(`subscriptionValidators:PaymentMethod`))]
      })), validatorBuilders.Object("iDealIssuer")]
})

export type PaymentMethodState = {
  input:PaymentMethod
  validator:Validator<PaymentMethod, PaymentMethod>,
  validatorResult:ValidatorResult
  isValid():boolean
}

export const initialPaymentMethodState : PaymentMethodState = ({
  input:emptyPaymentMethod,
  validator:paymentMethodValidator.setValueToValidate(emptyPaymentMethod,emptyPaymentMethod),
  validatorResult:validatorResultBuilders.validating(""),
  isValid:function(this:PaymentMethodState) { return this.input.paymentType != undefined && isValidatorPassed(this.validatorResult) }
})

export const paymentMethodStateUpdaters = {
  input:(u:Updater<PaymentMethodState["input"]>) : Updater<PaymentMethodState> =>
    s => {
      const newInput = u(s.input)
      return ({...s, input:newInput, validator:s.validator.setValueToValidate(newInput, newInput)})
    },
  validation:(u:Updater<PaymentMethodState["validator"]>) : Updater<PaymentMethodState> =>
    s => {
      const newValidator = u(s.validator)
      return ({...s, validator:newValidator, validatorResult:newValidator.evaluateResult() })
    }
}

export const paymentMethodUpdaters = {
  paymentType:(u:Updater<PaymentMethod["paymentType"]>) : Updater<PaymentMethod> =>
    s => ({...s, paymentType:u(s.paymentType)}),
  iDealIssuer:(u:Updater<PaymentMethod["iDealIssuer"]>) : Updater<PaymentMethod> =>
    s => ({...s, iDealIssuer:u(s.iDealIssuer)})
}
